import Vue from 'vue'

// ES6
import VueTyperPlugin from 'vue-typer'

Vue.use(VueTyperPlugin)
